import { useState } from "react";

import GerenciarCluster from '../../components/GerenciarCluster/GerenciarCluster';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';


export default function GerenciarClusterAdm() {
    //Notifier
    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });
    


    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <GerenciarCluster />
        
    </>
}